import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "quote-list"
}
const _hoisted_2 = { class: "quote-table" }
const _hoisted_3 = { class: "product-headline" }
const _hoisted_4 = { class: "product-name" }
const _hoisted_5 = { class: "product-price" }
const _hoisted_6 = { class: "quote-table-content" }
const _hoisted_7 = {
  key: 0,
  class: "quote-alt"
}

import { ref, onMounted } from "vue";
import AgilaButton from "frontend-component-templates/src/components/agilaButton.vue";
import productsApi from "../api/products";
import { PET_TYPE, PRODUCT_GROUP } from "../store/variables";
import { Product } from "../classes/product";
import { ProductGroup } from "../classes/productGroup";
import { featureIsDiff } from "../helper/general";
import ListContentRowComponent from "../components/sections/ListContentRowComponent.vue";
import { trackObject } from "../helper/tracking";
import { useFocusVisible } from "frontend-component-templates/src/composables/useFocusVisible";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteList',
  setup(__props) {

const selectedProductIdentifier = ref("TKS");
const petType = ref(PET_TYPE.DOG);
const selectedProductGroupId = ref(PRODUCT_GROUP.TKS);
const productGroup = ref<ProductGroup>();
const product = ref<Product>();
const showAllFields = ref<boolean>(false);

productsApi.setApiKeys();

onMounted(async () => {
  productGroup.value = await productsApi.getProductGroup(
    selectedProductGroupId.value,
    petType.value
  );
  product.value = productGroup.value?.products?.find(
    (product) => product.identifier === selectedProductIdentifier.value
  );
});

useFocusVisible();
checkDataAttributes();

function checkDataAttributes() {
  const quoteCalculationElement = document.getElementById("quote-calculation");
  const dataProduct = quoteCalculationElement.getAttribute("data-product");
  if (dataProduct || window.abList) {
    selectedProductIdentifier.value = dataProduct || window.abList;
    if (selectedProductIdentifier.value.indexOf("OPS") > -1) {
      selectedProductGroupId.value = PRODUCT_GROUP.OPS;
    } else if (selectedProductIdentifier.value.indexOf("HPS") > -1) {
      selectedProductGroupId.value = PRODUCT_GROUP.HPS;
    }
  }
  const dataPetType = quoteCalculationElement.getAttribute("data-pet-type");
  if (dataPetType === "dog") {
    petType.value = PET_TYPE.DOG;
  } else if (dataPetType === "cat") {
    petType.value = PET_TYPE.CAT;
  }
}

function selectProduct(): void {
  trackObject("select_item", [product.value], petType.value);

  const params = new URLSearchParams();
  params.set("pet", petType.value);
  params.set("productGroup", selectedProductGroupId.value);
  params.set("product", product.value.id);

  window.location.href =
    process.env.VUE_APP_ORIGIN + "antrag2/#/1/tier/typ?" + params.toString();
}

function navigateToAlt() {
  if (petType.value === PET_TYPE.DOG) {
    window.location.href =
      process.env.VUE_APP_ORIGIN +
      "versicherungen/hundeversicherung/hundekrankenversicherung";
  } else {
    window.location.href =
      process.env.VUE_APP_ORIGIN +
      "versicherungen/katzenversicherung/katzenkrankenversicherung";
  }
}

const noHeaderVisible = ref(false);
document.addEventListener("scroll", () => {
  const header = document
    .querySelector("#header > div")
    ?.shadowRoot?.querySelector("div > header");
  if (header) {
    const headerStyle = window.getComputedStyle(header);
    noHeaderVisible.value = headerStyle.display === "none";
  } else {
    noHeaderVisible.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  return (product.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["quote-table-head", {
          'no-header': noHeaderVisible.value,
        }])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(product.value.name), 1),
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(" ab " + _toDisplayString(product.value.getDisplayPrice()) + " ", 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "mtl.", -1))
              ])
            ]),
            _createVNode(AgilaButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (selectProduct())),
              text: product.value.name + ' wählen'
            }, null, 8, ["text"])
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productGroup.value.features, (feature) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: feature.id
              }, [
                (_unref(featureIsDiff)(feature, productGroup.value))
                  ? (_openBlock(), _createBlock(ListContentRowComponent, {
                      key: 0,
                      product: product.value,
                      feature: feature
                    }, null, 8, ["product", "feature"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("div", {
              class: "table-row show-all",
              tabindex: "0",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (showAllFields.value = !showAllFields.value), ["enter"])),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showAllFields.value = !showAllFields.value))
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Gesamte Leistungen ansehen", -1)),
              _createElementVNode("span", {
                class: _normalizeClass({
              'agila-icon-down': !showAllFields.value,
              'agila-icon-up': showAllFields.value,
            })
              }, null, 2)
            ], 32),
            (showAllFields.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(productGroup.value.features, (feature) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: feature.id
                  }, [
                    (!_unref(featureIsDiff)(feature, productGroup.value))
                      ? (_openBlock(), _createBlock(ListContentRowComponent, {
                          key: 0,
                          product: product.value,
                          feature: feature
                        }, null, 8, ["product", "feature"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ]),
        (selectedProductGroupId.value === _unref(PRODUCT_GROUP).OPS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "quote-alt-headline" }, " Du willst dein Tier noch besser absichern? ", -1)),
              _createVNode(AgilaButton, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateToAlt())),
                text: 'Zum Tierkrankenschutz',
                secondary: true
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "agila-icon-right-sm" }, null, -1)
                ])),
                _: 1,
                __: [6]
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})